import { eTipoPermissao } from '@/enums/ePermissoes';
export default [
    {
        description: 'Idioma',
        path: '/biblioteca/bibidioma',
        name: 'bibidioma',
        component: () => import('@/views/biblioteca/bibidioma/Index.vue'),
        meta: {
            permissions: [eTipoPermissao.BIB_IDIOMASNOVO_MENU_1300801699],
        },
        goesToMenu: true,
    },
    {
        description: 'Cadastro de Idioma',
        path: '/biblioteca/bibidioma/cadastro/:id?',
        parent: 'bibidioma',
        name: 'bibidioma_create',
        component: () => import('@/views/biblioteca/bibidioma/InclusaoEdicao.vue'),
        meta: {
            permissions: [eTipoPermissao.BIB_IDIOMASNOVO_MENU_1300801699],
        },
        goesToMenu: true,
    },
]
